import styled from "styled-components";

import Grid from "@anwb/poncho/components/grid";

export const TrainerGridWrapper = styled(Grid)`
  width: 100%;
  margin: 0 auto 1rem;
`;
